<div class="card m-2 p-5">
  <h4>Add Ancilliary Services</h4>
  <div class="paxpnhd p-1 bold">Name</div>
  <div class="card p-4 m-2">
    <ng-template [ngIf]="passengerDetails.length > 0">
      <div class="row mb-2" *ngFor="let passengerDetail of passengerDetails; let passengerIndex = index">
        <div class="col-md-4">
          <ul class="tkpn">
            <li class="">
              <button type="button" class="textgrayColor orderDBtn dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-user-tag"></i>
              </button>
              <!--<div class="infpn dropdown-menu in" style="top: 5px">
                  <b><i class="fa fa-receipt"></i> Ticket/Details</b>
                  <ul class="tkpn2">
                    <li class="divider"></li>
                  </ul>
                </div>-->
              <div class="showHideToggle dropdown-menu">
                <h4 class="TicketDetails" id="exampleModalLabel"><i class="fa fa-receipt"></i> Ticket/Details</h4>
                <ul class="tkpn2">
                  <!--ticket-->
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerTicketDetails.length > 0">
                    <li *ngFor="let ticketDetail of passengerDetail.passengerOtherDetails.passengerTicketDetails">
                      <div class="row">
                        <div class="col-md-1 pl-0 pr-0 text-right">
                      <ng-template [ngIf]="ticketDetail.ticketType === 'T'">
                        <i class="fa fa-ticket-alt"></i>
                      </ng-template>
                      <ng-template [ngIf]="ticketDetail.ticketType === 'J'">
                        <i class="fa fa-suitcase"></i>
                      </ng-template>
                      <ng-template [ngIf]="ticketDetail.ticketType === 'M'">
                        <i class="fa fa-utensils"></i>
                      </ng-template>
                      <ng-template [ngIf]="ticketDetail.ticketType === 'D'">
                        <i class="fa fa-wheelchair"></i>
                      </ng-template>
                      <ng-template [ngIf]="ticketDetail.ticketType === 'Q'">
                        <i class="fa fa-leaf"></i>
                      </ng-template>
                    </div>
                    <div class="col-md-5">TICKET NUMBER</div>
                    <div class="col-md-5">{{ ticketDetail.ticketNumber }}</div>
                    <div class="col-md-1"></div>
                  </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <!--bag-->
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerBaggageDetails.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerBaggageDetails">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="baIcn ba-check-bag ba-2xx"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1"></div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedBaggageDetail.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerSelectedBaggageDetail; let serviceIndex = index">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="baIcn ba-check-bag ba-2xx grn"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1 pl-0">
                          <a href="#" (click)="removeServiceFromPassenger('BAG', passengerIndex, serviceIndex)" class="deleteIcon" alt="Cancel Item">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <!--meal-->
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerMealDetails.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerMealDetails">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="fa fa-utensils"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1"></div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedMealDetails.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerSelectedMealDetails; let serviceIndex = index">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="fa fa-utensils grn"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1 pl-0">
                          <a href="#" (click)="removeServiceFromPassenger('MEAL', passengerIndex, serviceIndex)" class="deleteIcon" alt="Cancel Item">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <!--disablityService-->
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="fa fa-wheelchair"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1"></div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <!-- CARB -->
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="fa fa-leaf"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1"></div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                  <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length > 0">
                    <li *ngFor="let serviceDetail of passengerDetail.passengerOtherDetails.passengerSelectedProductClimateServiceDetail; let serviceIndex = index">
                      <div class="row">
                        <div class="col-md-1">
                          <i class="fa fa-leaf grn"></i>
                        </div>
                        <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                        <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                        <div class="col-md-1 pl-0">
                          <a href="#" (click)="removeServiceFromPassenger('CARB', passengerIndex, serviceIndex)" class="deleteIcon" alt="Cancel Item">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="divider"></li>
                  </ng-template>
                </ul>
              </div>
            </li>
          </ul>
          {{ passengerDetail.passengerName }} {{ passengerDetail.passengerSurName }}
        </div>
        <div class="col-md-1">{{ passengerDetail.passengerType }}</div>
        <div class="col-md-1"></div>
        <div class="col-md-2">
          <ng-template
            [ngIf]="
              passengerDetail.passengerOtherDetails.passengerBaggageDetails.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerMealDetails.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerSelectedBaggageDetail.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerSelectedMealDetails.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length === 0 &&
              passengerDetail.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length === 0
            "
          >
            <i class="fa fa-suitcase fa-off"> </i>
            <i class="fa fa-utensils fa-off"> </i>
            <i class="fa fa-wheelchair fa-off"> </i>
            <i class="fa fa-leaf fa-off"></i>
          </ng-template>
          <ng-template
            [ngIf]="
              passengerDetail.passengerOtherDetails.passengerBaggageDetails.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerMealDetails.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerSelectedBaggageDetail.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerSelectedMealDetails.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length > 0 ||
              passengerDetail.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length > 0
            "
          >
            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerBaggageDetails.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerBaggageDetails" class="fa fa-suitcase"> </i>
            </ng-template>
            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedBaggageDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerSelectedBaggageDetail" class="fa fa-suitcase grn"> </i>
            </ng-template>

            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerMealDetails.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerMealDetails" class="fa fa-utensils"> </i>
            </ng-template>
            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedMealDetails.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerSelectedMealDetails" class="fa fa-utensils grn"> </i>
            </ng-template>

            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail" class="fa fa-wheelchair"> </i>
            </ng-template>
            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerSelectedDisablityServiceDetail" class="fa fa-wheelchair grn"> </i>
            </ng-template>
              <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerDisablityServiceDetail" class="fa fa-wheelchair"> </i>
            </ng-template>
            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerSelectedDisablityServiceDetail" class="fa fa-wheelchair grn"> </i>
            </ng-template>

            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail" class="fa fa-leaf"> </i>
            </ng-template>
            <ng-template [ngIf]="passengerDetail.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length > 0">
              <i *ngFor="let baggage of passengerDetail.passengerOtherDetails.passengerSelectedProductClimateServiceDetail" class="fa fa-leaf grn"> </i>
            </ng-template>
          </ng-template>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-3">
          <button
            [class.dNone]="!check_button_available(passengerDetail.passengerId, 'BAG')"
            type="button"
            *ngIf="displayService === 'All' || displayService === 'BAG'"
            class="ba-btn ba-btn-smx-vthin ms-1 me-1 mb-2"
            (click)="displayServiceScreen(passengerIndex, 'BAG')"
            role="button"
            tooltip="ExcessBaggage"
          >
            Add
            <i class="fa fa-suitcase"></i>
          </button>
          <button
            [class.dNone]="!check_button_available(passengerDetail.passengerId, 'MEAL')"
            type="button"
            *ngIf="displayService === 'All' || displayService === 'MEAL'"
            class="ba-btn ba-btn-smx-vthin ms-1 me-1"
            (click)="displayServiceScreen(passengerIndex, 'MEAL')"
            role="button"
            tooltip="MEAL"
          >
            Add
            <i class="fa fa-utensils"></i>
          </button>
          <button
            [class.dNone]="!check_button_available(passengerDetail.passengerId, 'DisabilityAssistance')"
            type="button"
            *ngIf="displayService === 'All' || displayService === 'DisabilityAssistance'"
            class="ba-btn ba-btn-smx-vthin ms-1 me-1"
            (click)="displayServiceScreen(passengerIndex, 'DisabilityAssistance')"
            role="button"
            tooltip="DisabilityAssistance"
          >
            Add
            <i class="fa fa-wheelchair"></i>
          </button>
          <button
          [class.dNone]="!check_button_available(passengerDetail.passengerId, 'CARB')"
          type="button"
          *ngIf="displayService === 'All' || displayService === 'CARB'"
          class="ba-btn ba-btn-smx-vthin ms-1 me-1 mb-2"
          (click)="displayServiceScreen(passengerIndex, 'CARB')"
          role="button"
          tooltip="ExcessBaggage"
        >
          Add
          <i class="fa fa-leaf"></i>
        </button>
        </div>
      </div>
    </ng-template>
  </div>
  <div style="position: absolute; top: 20px; right: 20px">
    <p (click)="closeScreen()" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></p>
  </div>
  <div class="container mt-50 toplne text-right" *ngIf="displayService !== 'All'">
    <button class="ba-btn mt-30 btn-thin" role="button" type="button" id="changebk" (click)="ShowOrderView()"><i class="fa fa-shopping-basket"></i> CheckOut</button>
  </div>
</div>
